export * from './produto-altera-em-lote-component';